import React, { useContext } from "react";
import { SimpleContext } from "../../../../../../../store/context/simple-context";
// import ComplexTooltipSK from "./ComplexTooltipSK";
// import ComplexTooltipWK from "./ComplexTooltipWK";

const Tooltip = ({ optionName, tooltip }) => {
  const {
    translate: { t },
  } = useContext(SimpleContext);
  // switch (optionName) {
  //   case "SK":
  //     return <ComplexTooltipSK />;
  //   case "WK":
  //     return <ComplexTooltipWK />;
  //   default:
  //     return t(tooltip);
  // }
  return t(tooltip);
};

export default Tooltip;
